module.exports = __webpack_public_path__ + "static/media/hamburger.fc23b36e.svg";